<template>
  <div class="pa-10">
    <v-tabs v-model="tab" dark background-color="primary">
      <v-tab v-for="tab in tabs" :key="tab">
        {{ tab }}
      </v-tab>
    </v-tabs>
    <v-tabs-items v-if="!isAuth" v-model="tab">
      <v-tab-item>
        <login></login>
      </v-tab-item>
      <v-tab-item>
        <signup @success="tab = 0"></signup>
      </v-tab-item>
      <v-tab-item>
        <forgot-password @success="tab = 0"></forgot-password>
      </v-tab-item>
    </v-tabs-items>
    <v-tabs-items v-else v-model="tab">
      <v-tab-item>
        <profile></profile>
      </v-tab-item>
      <v-tab-item>
        <change-password></change-password>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import ChangePassword from "../components/settings/ChangePassword.vue";
import ForgotPassword from "../components/settings/ForgotPassword.vue";
import Login from "../components/settings/Login.vue";
import Profile from "../components/settings/Profile.vue";
import Signup from "../components/settings/Signup.vue";
export default {
  components: { Login, Signup, ChangePassword, Profile, ForgotPassword },
  data() {
    return {
      tab: 0,
    };
  },
  computed: {
    isAuth() {
      return this.$store.getters.user.MobileNo;
    },
    tabs() {
      let isAuth = ["Profile", "Change Password"];
      let isNot = ["Login", "Signup", "Forgot Password"];
      return this.isAuth ? isAuth : isNot;
    },
  },
  watch: {
    isAuth() {
      this.tab = 0;
    },
  },
};
</script>

<style>
</style>